import { render, staticRenderFns } from "./equityCenterBox.vue?vue&type=template&id=a6aa1db2&scoped=true"
import script from "./equityCenterBox.vue?vue&type=script&lang=js"
export * from "./equityCenterBox.vue?vue&type=script&lang=js"
import style0 from "./equityCenterBox.vue?vue&type=style&index=0&id=a6aa1db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aa1db2",
  null
  
)

export default component.exports